<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>经销商对账管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="queryInfo.time"
              @change="timechange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="8">
          <!--@click="exportExcel" -->
          <!-- <a class="aaaa" target="_blank" :href="'https://hsznttghpt.hsxsn.cn/exportExcel?data=' + this.multipleSelectionjson">
            <el-button size="mini" type="info">导出订单</el-button> 
          </a> -->
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time)">
            <el-button size="mini" type="info">导出对账</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index"></el-table-column>
        <el-table-column label="经销商" prop="agencyName" width="180px"></el-table-column>
        <el-table-column label="业务员" prop="saleman" align="center" width="180px"> </el-table-column>
        <el-table-column label="充值余额" prop="money" align="center" width="180px"> </el-table-column>
        <el-table-column label="授信账户" prop="creditMoney" align="center" width="180px"> </el-table-column>
        <el-table-column label="返点" prop="refund" align="center" width="180px"> </el-table-column>
        <el-table-column label="设备补贴" prop="subsidy" align="center" width="180px"> </el-table-column>
        <el-table-column label="未对账数" prop="ifaccount" align="center" width="180px"> </el-table-column>
        <!-- <el-table-column label="设备补贴" prop="uuid" align="center" width="180px"> </el-table-column> -->
        <el-table-column label="操作" width="250px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editOrder(scope.row.uuid)">查看对账列表</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog :visible.sync="desd" width="80%" >
        <Detail ref="detail"  :valueId="uuid"/>
    </el-dialog>
  </div>
</template>

<script>
import Detail from "./acdetail"
export default {
  components: {
    Detail
  },
  data () {
    return {
      exportUrl: 'https://hsznttghpt.hsxsn.cn/AccoutnList?mPhone=' + localStorage.getItem('phone'),
      canLook: 1,
      desd:false,
      uuid:'',
      // exportUrl: 'javascript:return false;',
      queryInfo: {
        query: '',
        status: -1,
        type: 0,
        time:"",
        pagenum: 1,
        pagesize: 10
      },
      statusValue: '全部',
      // 审核状态0未审核，1审核通过2拒绝
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '未审核', id: 0 },
        { value: '审核通过', id: 1 },
        { value: '拒绝', id: 2 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: 0 },
        { value: '常温', id: 1 },
        { value: '低温', id: 2 },
      ],
      total: 0,
      orderlist: [],
      editDialogVisible: false,
      editForm: {
        creditMoney: null,
        refund: null,
        subsidy: null,
        remarkl: null,
      },
      editFormRules: {
        creditMoney: [
          { required: true, message: '请输入授信额度', trigger: 'blur' },
        ],
      },
      selectId: null,
      multipleSelectionjson: null,
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {

    searchOrder () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 编辑
    editOrder (data) {
      console.log(data,'uuid')
      this.uuid = data,
      this.desd = true
     
    },
    timechange() {
      this.filterSelect()
    },

    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },

    // 确定
    async sure () {
      var phone = window.sessionStorage.getItem('phone')

      const { data: res } = await this.$http.post('admin/user/shouxin', {
        id: this.selectId,
        phone: phone,
        creditMoney: this.editForm.creditMoney,
        refund: this.editForm.refund,
        subsidy: this.editForm.subsidy,
        remark: this.editForm.remark,
      })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getOrderList()
      this.editDialogVisible = false
    },

    // 监听 switch 开关状态的改变
    async userStateChanged (userinfo) {
      console.log(userinfo)
      var phone = window.sessionStorage.getItem('phone')

      const { data: res } = await this.$http.post('/admin/users/userStateChanged', {
        sxstatus: userinfo.sxstatus,
        id: userinfo.id,
        phone: phone
      })
      if (res.code !== 200) {
        userinfo.sxstate = !userinfo.sxstate
        return this.$message.error('更新状态失败！')
      }
      this.$message.success('更新状态成功！')
    },

    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list) {
        this.multipleSelectionjson = JSON.stringify(list);
        // this.exportUrl = 'https://hsznttghpt.hsxsn.cn/jxsComsumeList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = "javascript:return false;"
      }
    },

    async getOrderList () {
      // console.log(this.queryInfo,'66666666666666666666666')
      // return
      const { data: res } = await this.$http.post('admin/users/getAllUsersWithDuizhang', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        this.orderlist = ''
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}
</style>
